// Lib
import gql from 'graphql-tag';

// Types
import { ACCOUNT_V2_AUTH, AUTH, MARBLE_SUBSCRIPTION } from '../types';

// Uses the slim org fragment (ACCOUNT_V2_AUTH, no `members`). The initial
// account load can run before any org-scoped token context exists — notably
// the magic-link path, where GetAccountData fires right after the token lands
// (useLogin) and before an org is selected. Requesting the auth-guarded
// `members` field there returns field-level `Forbidden`, which nullifies the
// non-null members list and collapses the whole response to `data: null`
// (same failure mode as createOrganization.members). Members are loaded
// lazily where actually needed.
export const getUserDataQuery = gql`
  query GetAccountData {
    account {
      ${ACCOUNT_V2_AUTH}
    }
  }
`;

export const getUserAuthsQuery = gql`
  query GetInitApplicationData {
    me {
      auths {
        ${AUTH}
      }
    }
  }
`;

export const getUserPaymentStatus = gql`
  query GetInitApplicationData {
    me {
      subscriptions {
        ${MARBLE_SUBSCRIPTION}
      }
    }
  }
`;
